// Contains core page JS for the "precedent" style

// Initialise Search Box behaviour
$(document).ready(() => {
   let searchBox = $('#top-search')
   let submitIcon = searchBox.find('.searchbox-icon');
   let inputBox = searchBox.find('.searchbox-input');
   let isOpen = false;
   submitIcon.click(() => {
      if (!isOpen){
         searchBox.addClass('searchbox-open');
         inputBox.focus();
         isOpen = true;
      } else {
         searchBox.removeClass('searchbox-open');
         inputBox.focusout();
         isOpen = false;
      }
   });
   submitIcon.mouseup(() => { return false; })
   searchBox.mouseup(() => { return false; });
   inputBox.keyup(() => {
      let inputVal = inputBox.val();
      inputVal = $.trim(inputVal).length;
      if( inputVal !== 0){
         submitIcon.css('display','none');
      } else {
         inputBox.val('');
         submitIcon.css('display','block');
      }
   })
   $(document).mouseup(() => {
      if (isOpen){
         submitIcon.css('display','block');
         submitIcon.click();
      }
   });
});

// Clone of top search for mobile search in footer
$(document).ready(() => {
   let searchBox = $('#bottom-search')
   let submitIcon = searchBox.find('.searchbox-icon');
   let inputBox = searchBox.find('.searchbox-input');
   let isOpen = false;
   submitIcon.click(() => {
      if (!isOpen){
         searchBox.addClass('searchbox-open');
         inputBox.focus();
         isOpen = true;
      } else {
         searchBox.removeClass('searchbox-open');
         inputBox.focusout();
         isOpen = false;
      }
   });
   submitIcon.mouseup(() => { return false; })
   searchBox.mouseup(() => { return false; });
   inputBox.keyup(() => {
      let inputVal = inputBox.val();
      inputVal = $.trim(inputVal).length;
      if( inputVal !== 0){
         submitIcon.css('display','none');
      } else {
         inputBox.val('');
         submitIcon.css('display','block');
      }
   })
   $(document).mouseup(() => {
      if (isOpen){
         submitIcon.css('display','block');
         submitIcon.click();
      }
   });
});


// Initialise Bootstrap tooltips
$(document).ready(() => {
   $('[data-toggle="tooltip"]').tooltip()
});

// Auto-expand Active menu item
$(document).ready(() => {
   $('.on-screen-menu li.active').parentsUntil('.on-screen-menu').filter('ul.collapse').each(function() {
      $(this).addClass('show')
      $(this).siblings('a.has-submenu').removeClass('collapsed')
   })
});
